import { useTranslation } from 'react-i18next'
import { LAUNCH_FLAG_KEYS } from '../../../utils/receivingConfig'

export const ReceivingHeader = ({ warehouse, launchFlags }) => {
  const { t } = useTranslation()
  return (
    <>
      <div className="text-lg font-semibold">
        {t('receiving_config.title')}
        {warehouse?.name && <span className="ml-2 text-gray-500 font-normal">· {warehouse.name}</span>}
      </div>
      {launchFlags && (
        <div className="flex items-center gap-2 ml-auto" title={t('receiving_config.launch_flags.managed_by_engineering')}>
          {LAUNCH_FLAG_KEYS.map(key => (
            <span
              key={key}
              className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${launchFlags[key] ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600'}`}
            >
              {t(`receiving_config.launch_flags.${key}`)}
              {!launchFlags[key] && ` ${t('receiving_config.launch_flags.off_suffix')}`}
            </span>
          ))}
        </div>
      )}
    </>
  )
}
